import _ from 'lodash'
import { Form, FormPage } from './Form'
import { FlowmapParser, getTypedXmlAttributes } from '@fusion-advantage/backcompat'
import L6ToL5Processor from './L6ToL5/L6ToL5Processor'
import { getConceptPersisters } from '../persistence/ConceptPersister'
import { LibraryIconProp } from '../LibraryIconProp'
import { ReturnedEntityState } from '../persistence/ReturnedEntity'
import { OncologyItem } from '../oncology/OncologyItem'
import { FormCalcScript } from '../calc3/FormCalcScript'
import { UlcerItem } from '../ulcer/UlcerItem'
import { Directory } from '../directory/Directory'

export const parseForm = (flowMap: string): Form => {
	const rParser = FlowmapParser.create(flowMap)
	if(rParser.isErr()) {
		// TODO
		throw rParser.error
	}
	const parser = rParser.value
	const doc = parser.doc
	const rootNode = parser.rootNode
	const pages: FormPage[] = parser.pageNodes.map(node => {
		let pageAttr = getTypedXmlAttributes(node)
		// more we could do for error checking and display here,
		// but for now it seems low priority
		// (pretty easy to tell when it's broken!)
		return {
			title: pageAttr['title'] as string,
			icon: pageAttr['icon'] as LibraryIconProp,
		}
	})
	const directoryBlob = parser.namedBlobs.get('directory')
	// TODO fix!
	let dirJson = directoryBlob ? JSON.parse(directoryBlob) : []
	const valuelistBlob = parser.namedBlobs.get('valuelist')
	// TODO fix!
	let vlJson: {Name: string, Item: string}[] = valuelistBlob ? JSON.parse(valuelistBlob) : []
	const directory = new Directory(dirJson, vlJson)
	let oncologyData: OncologyItem[] = []
	const oncologyDataBlob = parser.namedBlobs.get('oncologyData')
	if(oncologyDataBlob) {
		let oJson = JSON.parse(oncologyDataBlob)
		oncologyData = oJson
	}
	let ulcerData: UlcerItem[] = []
	const ulcerDataBlob = parser.namedBlobs.get('ulcerData')
	if(ulcerDataBlob) {
		let uJson = JSON.parse(ulcerDataBlob)
		ulcerData = uJson
	}
	let returnedEntities: ReturnedEntityState|null = null
	const returnedEntityStateBlob = parser.namedBlobs.get('returnedEntityState')
	// this is allowed to not exist for golibform to generate ProposedEntitiesPayload
	if(returnedEntityStateBlob) {
		returnedEntities = JSON.parse(returnedEntityStateBlob)
	}
	let calcScripts: FormCalcScript[] = []
	const calcScriptsBlob = parser.namedBlobs.get('calcScripts')
	if(calcScriptsBlob) {
		calcScripts = JSON.parse(calcScriptsBlob)
	}
	const processor = new L6ToL5Processor(doc, rootNode, directory)
	processor.process()
	const concepts = processor.concepts
	const persisters = getConceptPersisters(concepts)
	return {
		doc,
		rootNode,
		pages,
		calcScripts,
		concepts,
		persisters,
		returnedEntities,
		oncologyData,
		ulcerData,
	}
}
